import axiosInstance from "../axiosInstance";

export const fetchVendorCities = async (state) => {
    try {
        const response = await axiosInstance.get(`/location/vendors/states/${ state }/cities`);

        if(response.status === 200){
            return response.data;
        }
        else{
            return [];
        }
    } catch (error) {
        console.error("Error fetching states:", error);
        return [];
    }
};
